module.exports = __webpack_public_path__ + "static/media/ard-kka_interaktive_grafik.7ba7463c.jpg";